<!-- 公司通告 -->
<template>
  <div class='notices_c'>
    <!-- 头部  -->
    <div class='page_notices'>
    <div class="page_header">
      <span>
        {{$t('notices.h_t')}}
      </span>
    </div>
    </div>
    <div class="data">
        <a target="_blank" :href="item.FullUrl" class="item" v-for="item in pagination.data">
          <div class="title">{{item.New_tip}}</div>
          <div class="time">{{item.PublishTime}}</div>
        </a>
     </div>
     <div class="pagination-wrapper">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="searchForm.pageSize"
        :total="pagination.totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }],
     
    }
  },
  components: {},
  data () {
    return {
      cultureArr: [],
      pageTitle: '广州市熵达贸易有限公司-公司通告',
      metaName:'广州市熵达贸易有限公司-公司通告',
      metaContent:'广州市熵达贸易有限公司-公司通告',
      keyword:'广州市熵达贸易有限公司,熵达贸易,熵达',
      description:'广州市熵达贸易有限公司是一家以',
      pagination: {
          totalCount: 0,
          data: []
      },
       searchForm: {
          pageIndex: 1,
          pageSize: 6,
        },
    };
  },
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.searchForm.pageSize = val;
        this.getNotices();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.searchForm.pageIndex = val;
        this.getNotices();
      },
    async getNotices () {
      let notice = await GetNotices(this.searchForm.pageIndex, this.searchForm.pageSize);
      if(notice.TotalCount>0){
        let data = notice.Data;
        data.map(item => {
          item.PublishTime = this.formatDate(item.CreateTime.replace('T',' '));
          let fullUrl = item.PdfUrl||item.PdfImgUrl ;
          item.FullUrl = process.env.BASE_URL + fullUrl;
        });
        this.pagination.totalCount = notice.TotalCount;
        this.pagination.data = data;
      }else{
        this.pagination.data=[]
        this.pagination.totalCount=0
      }
      console.log(notice)
    },
    formatDate(dateStr) {
        if (!dateStr) return dateStr;
        try {
          let date = new Date(dateStr);
          console.log('date',date)
          let day = date.getDate(), month = date.getMonth() + 1, year = date.getFullYear();
          
          console.log('date',day,month,year)
          // if (day < 10) day = '0' + day;
          // if (month < 10) day = '0' + month;
          
          console.log('date',day,month,year)
          return (day<10?'0'+day:day) + '-' + (month<10?'0'+month:month) + '-' + year;
        } catch (ex) {
        }
        return dateStr;
      },
  },
  created () {

  },
  mounted () {
    this.getNotices();
  },
}
</script>
<style lang='scss' scoped>
.notices_c{
  box-sizing: border-box;
  overflow-x: hidden;
}
.page_notices {
  width: 100%;
  padding-top: 96px;
  height: 239px;
  padding-left: 31px;
  // background: url('~@/assets/images/notices_bg.png') no-repeat;
  background-size: 100% 100%;
  text-align: left;
  span {
    font-size: 48px;
    font-family: AlibabaPuHuiTi;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.26);
  }
}
 .data {
      
    padding: 95px 30px 40px 21px;
      margin-bottom: 1.5vw;

      .item {
        &:hover {
          .title {
            text-align: center;
            color: #38a2b4;
          }
        }

        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // flex-direction: column;
        padding: 3.0vw 10px 3.0vw 10px;
        border-bottom: 2px solid #4799bf;

        .title {
          font-weight: bold;
          font-size: 1.88vw;
          // line-height: 3.13vw;
          color: #273a63;
          white-space: nowrap;
          overflow:hidden;
          text-align: left;
          width:70%;
        }

        .time {
          font-size: 0.94vw;
          line-height: 1.67vw;
          padding-top:70px;
          width:30%;
          text-align: right;
        }
      }

    }
.pagination-wrapper {
      text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/view/notices/index.vue